import { jsx as l, jsxs as o } from "react/jsx-runtime";
import { createSvgIcon as e } from "@mui/material";
import { A as S2, a as A2, C as g2, I as y2, T as P2, W as k2 } from "../Warning-RmgMSYCd.js";
const r = e(
  /* @__PURE__ */ l(
    "path",
    {
      fill: "currentColor",
      d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3m0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22"
    }
  ),
  "AccountCircle"
), d = e(
  /* @__PURE__ */ l(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M2.3746 11.2929 1.6675 12l.707.7071 8.5924 8.5923.7071.7071.7071-.7071 5.3352-5.3353-1.4142-1.4142-4.6281 4.6281L4.496 12l7.178-7.1781L16.3021 9.45l1.4142-1.4142-5.3352-5.3352-.7071-.7071-.7071.707zm20.8848 1.7011h-2.0162l-.0014 2.0068-2-.0014.0014-2.0054h-1.9838v-2h1.9851l.0014-1.9946 2 .0014-.0014 1.9932h2.0149z",
      clipRule: "evenodd"
    }
  ),
  "AddComponent"
), v = e(
  [
    /* @__PURE__ */ l("g", { children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 5H4v2h6zM2 3v18h14.0008v-2H4V9h16v6.005h2V7H12V3zm18.0055 20.0162v-2.0163l-2.0069-.0013.0014-2 2.0055.0013v-1.9837h2v1.9851L24 19.0027l-.0014 2-1.9931-.0014v2.0149z",
        clipRule: "evenodd"
      }
    ) }, "0"),
    /* @__PURE__ */ l("defs", {}, "1")
  ],
  "AddFolder"
), h = e(
  [
    /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M21.0022 2h-6.18c-.42-1.16-1.52-2-2.82-2s-2.4.84-2.82 2h-6.18v20h12.0211v-2H5.0022V4h2v3h10V4h2v12h2zm-9 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1",
        clipRule: "evenodd"
      },
      "0"
    ),
    /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        d: "M20.9997 22.0047h2.0028V20.013h-2.0028V18h-1.9998v2.013h-2.0024l.0003 1.9917h2.0021V24h1.9998z"
      },
      "1"
    )
  ],
  "AddNotes"
), t = e(
  [
    /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M15 6H9V3H7v3H3v15h9v-2H5V8h14v4h2V6h-4V3h-2z",
        clipRule: "evenodd"
      },
      "0"
    ),
    /* @__PURE__ */ l("path", { fill: "currentColor", fillRule: "evenodd", d: "M16 18v3h2v-3h3v-2h-3v-3h-2v3h-3v2z", clipRule: "evenodd" }, "1")
  ],
  "AddToCalendar"
), i = e(
  [
    /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        d: "M17 13c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4m0 1.38c.62 0 1.12.51 1.12 1.12s-.51 1.12-1.12 1.12-1.12-.51-1.12-1.12.5-1.12 1.12-1.12m0 5.37c-.93 0-1.74-.46-2.24-1.17.05-.72 1.51-1.08 2.24-1.08s2.19.36 2.24 1.08c-.5.71-1.31 1.17-2.24 1.17"
      },
      "0"
    ),
    /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        d: "M17 11c.34 0 .67.04 1 .09V6.27L10.5 3 3 6.27v4.91c0 4.54 3.2 8.79 7.5 9.82.55-.13 1.08-.32 1.6-.55-.69-.98-1.1-2.17-1.1-3.45 0-3.31 2.69-6 6-6"
      },
      "1"
    )
  ],
  "AdminPanelSettings"
), u = e(
  /* @__PURE__ */ l(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M3 5h11V3H3zm0 2h3v2H3zm0 8h3v2H3zm0-4h2v2H3zm13 8H3v2h13zm-4-4c1.6569 0 3-1.3431 3-3s-1.3431-3-3-3-3 1.3431-3 3 1.3431 3 3 3m0 2c1.0191 0 1.967-.3049 2.7574-.8284l4.8097 4.8097 1.4142-1.4143-4.8097-4.8096A4.977 4.977 0 0 0 17 12c0-2.7614-2.2386-5-5-5s-5 2.2386-5 5 2.2386 5 5 5",
      clipRule: "evenodd"
    }
  ),
  "AdvancedSearch"
), s = e(
  /* @__PURE__ */ l(
    "path",
    {
      fill: "currentColor",
      d: "M22 16v-2l-8.5-5V3.5c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5V9L2 14v2l8.5-2.5V19L8 20.5V22l4-1 4 1v-1.5L13.5 19v-5.5z"
    }
  ),
  "AirplanemodeActiveOutlined"
), p = e(
  /* @__PURE__ */ l(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M12 2c-2.326 0-3.8761.9915-4.8115 2.2907C6.2898 5.5389 6 7.0067 6 8v10H3v2h7c0 1.1046.8954 2 2 2s2-.8954 2-2h7v-2h-3V8c0-.9934-.2898-2.4611-1.1885-3.7093C15.8761 2.9915 14.3259 2 12 2m0 16h4V8c0-.6733-.2102-1.7055-.8115-2.5407C14.6239 4.6751 13.6741 4 12 4s-2.6239.6751-3.1885 1.4593C8.2102 6.2945 8 7.3267 8 8v10z",
      clipRule: "evenodd"
    }
  ),
  "Alarm"
), a = e(
  /* @__PURE__ */ l(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M2 4c0 .7403.4022 1.3866 1 1.7324v12.5352c-.5978.3458-1 .9921-1 1.7324 0 1.1046.8954 2 2 2 .7403 0 1.3866-.4022 1.7324-1h12.5352c.3458.5978.9921 1 1.7324 1 1.1046 0 2-.8954 2-2 0-.7403-.4022-1.3866-1-1.7324V5.7324c.5978-.3458 1-.9921 1-1.7324 0-1.1046-.8954-2-2-2-.7403 0-1.3866.4022-1.7324 1H5.7324C5.3866 2.4022 4.7403 2 4 2c-1.1046 0-2 .8954-2 2m17 14.2676V5.7324A2.01 2.01 0 0 1 18.2676 5H5.7324A2.01 2.01 0 0 1 5 5.7324v12.5352c.3036.1756.5568.4288.7324.7324h12.5352A2.01 2.01 0 0 1 19 18.2676",
      clipRule: "evenodd"
    }
  ),
  "Area"
), z = e(
  /* @__PURE__ */ l("path", { fill: "currentColor", d: "m20 12-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8z" }),
  "ArrowDown"
), f = e(
  /* @__PURE__ */ l("path", { fill: "currentColor", d: "M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20z" }),
  "ArrowLeft"
), C = e(
  /* @__PURE__ */ l("path", { fill: "currentColor", d: "m12 4-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z" }),
  "ArrowRight"
), m = e(
  /* @__PURE__ */ l(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M12.207 2 8.1035 6.1036l.707.707 2.3965-2.3964v4.7929h2V4.4142l2.3965 2.3965.7071-.7071zM6.1035 8.1035 2 12.2071l4.1036 4.1035.707-.7071-2.3964-2.3964h15.5856l-2.3964 2.3964.7071.7071 4.1036-4.1035-4.1036-4.1036-.7071.7072 2.3965 2.3964H4.4142l2.3965-2.3964zm2 10.2071 4.1035 4.1036 4.1036-4.1036-.7071-.7071L13.207 20v-4.7929h-2V20l-2.3964-2.3965z",
      clipRule: "evenodd"
    }
  ),
  "Arrows"
), M = e(
  /* @__PURE__ */ l("path", { fill: "currentColor", d: "m4 12 1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8z" }),
  "ArrowUp"
), R = e(
  /* @__PURE__ */ l("path", { fill: "currentColor", fillRule: "evenodd", d: "M4 4h7V2h2v2h7v2H4zm3 16V9h10v11zM5 7h14v15H5z", clipRule: "evenodd" }),
  "Bin"
), H = e(
  /* @__PURE__ */ l("path", { fill: "currentColor", fillRule: "evenodd", d: "m12 16 8 6V2H4v20zm-6 2 6-4.5 6 4.5V4H6z", clipRule: "evenodd" }),
  "Bookmark"
), V = e(/* @__PURE__ */ l("path", { fill: "currentColor", d: "M3 18h18v-2H3zm0-5h18v-2H3zm0-7v2h18V6z" }), "BurgerMenu"), L = e(
  [
    /* @__PURE__ */ l("path", { fill: "currentColor", d: "M4 2h16v10h-2V4H6v16h6v2H4z" }, "0"),
    /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M16 20c-2.2091 0-4-1.7909-4-4s1.7909-4 4-4 4 1.7909 4 4a3.98 3.98 0 0 1-.5586 2.04l2.5931 2.593-1.4015 1.4016-2.5931-2.5931A3.98 3.98 0 0 1 16 20m.0239-1.8093c1.1967 0 2.1668-.9701 2.1668-2.1668s-.9701-2.1668-2.1668-2.1668-2.1668.9701-2.1668 2.1668.9701 2.1668 2.1668 2.1668",
        clipRule: "evenodd"
      },
      "1"
    ),
    /* @__PURE__ */ l("path", { fill: "currentColor", d: "M16 6H8v2h8zm-8 4h4v2H8zm3 4H8v2h3z" }, "2")
  ],
  "CaseStudy"
), S = e(
  /* @__PURE__ */ l(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M13 4v12h-2V4zM9 2h6v16H9zM2 21v-2h20v2zm18-5V8h-2v8zm2-10h-6v12h6zM6 13v3H4v-3zm-4-2h6v7H2z",
      clipRule: "evenodd"
    }
  ),
  "Chart"
), A = e(
  [
    /* @__PURE__ */ l("path", { fill: "none", stroke: "currentColor", strokeWidth: "2", d: "M6 17h-.4142l-.293.2929L3 19.5858V3h18v14z" }, "0"),
    /* @__PURE__ */ l("path", { fill: "currentColor", d: "M6 7h12v2H6zm0 4h12v2H6z" }, "1")
  ],
  "Chat"
), g = e(
  /* @__PURE__ */ l("path", { fill: "currentColor", d: "M15.705 7.41 14.295 6l-6 6 6 6 1.41-1.41-4.58-4.59z" }),
  "ChevronLeft"
), y = e(
  /* @__PURE__ */ l("path", { fill: "currentColor", d: "m12 8.295-6 6 1.41 1.41 4.59-4.58 4.59 4.58 1.41-1.41z" }),
  "ChevronUp"
), P = e(
  /* @__PURE__ */ l(
    "path",
    {
      fill: "currentColor",
      d: "M16.59 9.41 18 8l-6-6-6 6 1.41 1.41L12 4.83zm0 5.18L18 16l-6 6-6-6 1.41-1.41L12 19.17z"
    }
  ),
  "ChevronUpDown"
), k = e(
  /* @__PURE__ */ l(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M22 12c0 5.5228-4.4772 10-10 10S2 17.5228 2 12 6.4772 2 12 2s10 4.4772 10 10M4.0725 12c0 4.3782 3.5493 7.9275 7.9275 7.9275S19.9275 16.3782 19.9275 12 16.3782 4.0725 12 4.0725 4.0725 7.6218 4.0725 12",
      clipRule: "evenodd"
    }
  ),
  "Circle"
), w = e(
  /* @__PURE__ */ l(
    "path",
    {
      fill: "currentColor",
      d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
    }
  ),
  "Close"
), q = e(
  /* @__PURE__ */ l("path", { fill: "none", stroke: "currentColor", strokeWidth: "2", d: "M12 3.4142 20.5858 12 12 20.5858 3.4142 12z" }),
  "Component"
), D = e(
  /* @__PURE__ */ l(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M5 5h4v4H5zm-2 6V3h8v8zm2 4h4v4H5zm-2 6v-8h8v8zm16-6h-4v4h4zm-6-2v8h8v-8zm2-8h4v4h-4zm-2 6V3h8v8z",
      clipRule: "evenodd"
    }
  ),
  "Composite"
), F = e(
  /* @__PURE__ */ l(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M8 2H6v4H2v2h6zm8 0h2v4h4v2h-6zm2 20h-2v-6h6v2h-4zM8 22H6v-4H2v-2h6z",
      clipRule: "evenodd"
    }
  ),
  "Compress"
), T = e(
  /* @__PURE__ */ l(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2m0 16H8V7h11z",
      clipRule: "evenodd"
    }
  ),
  "ContentCopy"
), U = e(
  /* @__PURE__ */ l("path", { fill: "currentColor", d: "M16 1H2v16h2V3h12zm5 4H6v18h15zm-2 16H8V7h11z" }),
  "ContentCopySharp"
), b = e(
  /* @__PURE__ */ l(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M13 2h-2v3.0709C7.9343 5.5094 5.5094 7.9343 5.0709 11H2v2h3.0709c.4385 3.0657 2.8634 5.4906 5.9291 5.9291V22h2v-3.0709c3.0657-.4385 5.4906-2.8634 5.9291-5.9291H22v-2h-3.0709C18.4906 7.9343 16.0657 5.5094 13 5.0709zm-1 15c-2.7614 0-5-2.2386-5-5s2.2386-5 5-5 5 2.2386 5 5-2.2386 5-5 5m0-3c1.1046 0 2-.8954 2-2s-.8954-2-2-2-2 .8954-2 2 .8954 2 2 2",
      clipRule: "evenodd"
    }
  ),
  "Coordinates"
), E = e(
  /* @__PURE__ */ l(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M13 19.9381c3.6187-.4512 6.4869-3.3194 6.9381-6.9381H16v-2h3.9381C19.4869 7.3813 16.6187 4.5131 13 4.0619V8h-2V4.0619C7.3813 4.513 4.5131 7.3813 4.0619 11H8v2H4.0619C4.513 16.6187 7.3813 19.4869 11 19.9381V16h2zM12 22c5.5228 0 10-4.4772 10-10S17.5228 2 12 2 2 6.4772 2 12s4.4772 10 10 10",
      clipRule: "evenodd"
    }
  ),
  "CrosshairsInner"
), O = e(
  /* @__PURE__ */ l(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M11 2h2v3.0709c3.0657.4385 5.4906 2.8634 5.9291 5.9291H22v2h-3.0709c-.4385 3.0657-2.8634 5.4906-5.9291 5.9291V22h-2v-3.0709C7.9343 18.4906 5.5094 16.0657 5.0709 13H2v-2h3.0709C5.5094 7.9343 7.9343 5.5094 11 5.0709zM7 12c0 2.7614 2.2386 5 5 5s5-2.2386 5-5-2.2386-5-5-5-5 2.2386-5 5",
      clipRule: "evenodd"
    }
  ),
  "CrosshairsOuter"
), Q = e(
  [
    /* @__PURE__ */ l("g", { fill: "currentColor", children: /* @__PURE__ */ l("path", { d: "M7.3253 12.59 5.9153 14l6 6 6-6-1.41-1.41-4.59 4.58zm0-8.59-1.41 1.41 6 6 6-6-1.41-1.41-4.59 4.58z" }) }, "0"),
    /* @__PURE__ */ l("defs", {}, "1")
  ],
  "DoubleChevronDown"
), x = e(
  /* @__PURE__ */ l(
    "path",
    {
      fill: "currentColor",
      d: "M11.4102 7.41 10.0002 6l-6 6 6 6 1.41-1.41-4.58-4.59zm8.4202 0L18.4204 6l-6 6 6 6 1.41-1.41-4.58-4.59z"
    }
  ),
  "DoubleChevronLeft"
), I = e(
  /* @__PURE__ */ l(
    "path",
    {
      fill: "currentColor",
      d: "M12.42 7.41 13.83 6l6 6-6 6-1.41-1.41L17 12zM4 7.41 5.41 6l5.9999 6-6 6L4 16.59 8.58 12z"
    }
  ),
  "DoubleChevronRight"
), B = e(
  [
    /* @__PURE__ */ l("g", { fill: "currentColor", children: /* @__PURE__ */ l("path", { d: "M7.3253 11.41 5.9153 10l6-6 6 6-1.41 1.41-4.59-4.58zm0 8.59-1.41-1.41 6-6 6 6-1.41 1.41-4.59-4.58z" }) }, "0"),
    /* @__PURE__ */ l("defs", {}, "1")
  ],
  "DoubleChevronUp"
), G = e(
  /* @__PURE__ */ l(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M13.0001 14.716V2h-2v12.716l-4.8218-4.4508-1.3565 1.4696L12 18.3609l7.1782-6.6261-1.3565-1.4696zM4 16H2v6h20v-6h-2v4H4z",
      clipRule: "evenodd"
    }
  ),
  "Download"
), W = e(
  /* @__PURE__ */ l(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M9 7c-1.1046 0-2-.8954-2-2s.8954-2 2-2 2 .8954 2 2-.8954 2-2 2m-2 5c0 1.1046.8954 2 2 2s2-.8954 2-2-.8954-2-2-2-2 .8954-2 2m6 0c0 1.1046.8954 2 2 2s2-.8954 2-2-.8954-2-2-2-2 .8954-2 2m0-7c0 1.1046.8954 2 2 2s2-.8954 2-2-.8954-2-2-2-2 .8954-2 2M9 21c-1.1046 0-2-.8954-2-2s.8954-2 2-2 2 .8954 2 2-.8954 2-2 2m4-2c0 1.1046.8954 2 2 2s2-.8954 2-2-.8954-2-2-2-2 .8954-2 2",
      clipRule: "evenodd"
    }
  ),
  "Drag"
), Z = e(
  /* @__PURE__ */ l(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M18.53 2c-.25 0-.51.1-.7.29L16 4.12l3.75 3.75 1.83-1.83c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.2-.2-.45-.29-.71-.29M9 14.0784v.9215h.9216L16.4215 8.5l-.9216-.9216zm5.0857-7.9142L7 13.25V17h3.75l7.0857-7.0857L19.2499 8.5l-1.4142-1.4142-.9215-.9216L15.4999 4.75zM12 3H3v18h18v-9h-2v7H5V5h7z",
      clipRule: "evenodd"
    }
  ),
  "Edit"
), N = e(
  /* @__PURE__ */ l(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M20 8.283V18H4V8.283l7.4785 4.5703.5215.3186.5215-.3186zM19.9005 6H4.0996L12 10.8281zM2 4h20v16H2z",
      clipRule: "evenodd"
    }
  ),
  "Envelope"
), j = e(
  /* @__PURE__ */ l(
    "path",
    {
      stroke: "currentColor",
      strokeWidth: "2",
      d: "M6.9385 8.7952c-.2814.2462-.506.5324-.6857.8377l-.6261-.203c.1668-.2787.3832-.5542.6598-.7982.5601-.494 1.4332-.9187 2.8235-.9187 1.0426 0 1.8658.3624 2.7717.8133q.108.0539.221.111c.8086.4077 1.8083.9117 2.9573.9117.8838 0 1.6032-.2906 2.1476-.8282.2422-.2392.4331-.5111.587-.7935l.6107.2092c-.158.2926-.3625.577-.6281.8251-.5101.4767-1.3289.8994-2.7172.8994-1.0426 0-1.8658-.3624-2.7717-.8132a45 45 0 0 1-.221-.111c-.8087-.4077-1.8084-.9118-2.9573-.9118-.8656 0-1.5989.2691-2.1715.7702Zm10.2691 6.3856c.2422-.2392.4331-.5111.587-.7935l.6107.2092c-.158.2926-.3625.5769-.6281.8251-.5101.4767-1.3289.8994-2.7172.8994-1.0426 0-1.8658-.3624-2.7717-.8132a52 52 0 0 1-.221-.111c-.8087-.4077-1.8084-.9118-2.9573-.9118-.8656 0-1.5989.2691-2.1715.7702-.2814.2462-.506.5324-.6857.8377l-.6261-.203c.1668-.2787.3832-.5542.6598-.7982.5601-.4941 1.4332-.9187 2.8235-.9187 1.0426 0 1.8658.3624 2.7717.8133q.108.0538.221.1109c.8086.4078 1.8083.9118 2.9573.9118.8838 0 1.6032-.2906 2.1476-.8282Z"
    }
  ),
  "Equivalent"
), K = e(
  /* @__PURE__ */ l(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M2 2h6v2H4v4H2zm0 14v6h6v-2H4v-4zm18 0v4h-4v2h6v-6zm2-8V2h-6v2h4v4z",
      clipRule: "evenodd"
    }
  ),
  "Expand"
), J = e(
  /* @__PURE__ */ l(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M12.044 17c-4.9288 0-7.2768-3.2193-7.9448-5 .668-1.7807 3.016-5 7.9448-5s7.2769 3.2193 7.9449 5c-.668 1.7807-3.016 5-7.9449 5m0-12c-6.3125 0-9.266 4.4064-9.9578 6.7127L2 12l.0862.2873C2.7781 14.5936 5.7315 19 12.044 19s9.266-4.4064 9.9579-6.7127L22.0881 12l-.0862-.2873C21.31 9.4064 18.3565 5 12.044 5m-.0001 10c1.6569 0 3-1.3431 3-3s-1.3431-3-3-3-3 1.3431-3 3 1.3432 3 3 3",
      clipRule: "evenodd"
    }
  ),
  "Eye"
), X = e(
  /* @__PURE__ */ l(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M19.5439 3 3.109 19.4348l1.4142 1.4142L20.9581 4.4142zM12.044 19c-1.3781 0-2.5961-.21-3.6654-.5623l1.6357-1.6358c.6215.127 1.2971.1981 2.0297.1981 4.9289 0 7.2769-3.2193 7.9449-5-.3161-.8426-1.0083-2.0073-2.1721-3.0006l1.4175-1.4175c1.5494 1.3717 2.4291 3.0025 2.7676 4.1308l.0862.2873-.0862.2873C21.31 14.5936 18.3565 19 12.044 19m0-12c.6766 0 1.3046.0607 1.8862.17l1.6495-1.6495C14.5419 5.1935 13.3667 5 12.044 5c-6.3125 0-9.266 4.4064-9.9578 6.7127L2 12l.0862.2873c.3318 1.1061 1.1838 2.6952 2.677 4.0496l1.4161-1.416C5.071 13.9454 4.407 12.8201 4.0992 12c.668-1.7807 3.016-5 7.9448-5",
      clipRule: "evenodd"
    }
  ),
  "EyeHidden"
), Y = e(
  /* @__PURE__ */ l(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M11 13V4H6v16h12v-7zm9-1.5V22H4V2h8zm-7-5.2076L16.9643 11H13z",
      clipRule: "evenodd"
    }
  ),
  "File"
), _ = e(
  /* @__PURE__ */ l("path", { fill: "currentColor", fillRule: "evenodd", d: "M3 6v2h18V6zm7 12h4v-2h-4zm8-5H6v-2h12z", clipRule: "evenodd" }),
  "Filter"
), $ = e(
  /* @__PURE__ */ l("path", { fill: "currentColor", fillRule: "evenodd", d: "M4 5h6v2H4zM2 7V3h10v4h10v14H2zm2 2v10h16V9z", clipRule: "evenodd" }),
  "Folder"
), l1 = e(
  /* @__PURE__ */ l(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M4 5h6v2H4zM2 7V3h10v4h10v14H2zm16 4h-2v2h-2v2h2v2h2v-2h2v-2h-2z",
      clipRule: "evenodd"
    }
  ),
  "FolderPlus"
), e1 = e(
  /* @__PURE__ */ l(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M5 5H3V3h2zm0 4H3V7h2zm2 12h2v-2H7zm-2-8H3v-2h2zm-2 8h2v-2H3zm2-4H3v-2h2zm6 4h2v-2h-2zm10 0h-2v-2h2zm-6 0h2v-2h-2zm-4-10-3.5 3.5L6 13l5-5 4 4 4.5-4.5 1.41 1.41L15 15z",
      clipRule: "evenodd"
    }
  ),
  "Graph"
), o1 = e(
  /* @__PURE__ */ l(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M22 9V7h-2v2h-2v2h2v2h2v-2h2V9zM8 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4m0-6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2m0 7c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4m6 5H2v-.99C2.2 16.29 5.3 15 8 15s5.8 1.29 6 2zM12.51 4.05C13.43 5.11 14 6.49 14 8s-.57 2.89-1.49 3.95C14.47 11.7 16 10.04 16 8s-1.53-3.7-3.49-3.95m4.02 9.78C17.42 14.66 18 15.7 18 17v3h2v-3c0-1.45-1.59-2.51-3.47-3.17",
      clipRule: "evenodd"
    }
  ),
  "GroupAdd"
), c1 = e(
  /* @__PURE__ */ l(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M24 9v2h-6V9zM8 4C5.79 4 4 5.79 4 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4m0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2m0 3c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4m6 5H2v-.99C2.2 16.29 5.3 15 8 15s5.8 1.29 6 2zM12.51 4.05C13.43 5.11 14 6.49 14 8s-.57 2.89-1.49 3.95C14.47 11.7 16 10.04 16 8s-1.53-3.7-3.49-3.95m4.02 9.78C17.42 14.66 18 15.7 18 17v3h2v-3c0-1.45-1.59-2.51-3.47-3.17",
      clipRule: "evenodd"
    }
  ),
  "GroupRemove"
), n1 = e(
  /* @__PURE__ */ l(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "m10.55 19.855 1.45 1.32 1.45-1.31.0395-.0359C18.6174 15.1692 22 12.0953 22 8.325c0-3.08-2.42-5.5-5.5-5.5-1.0972 0-2.1666.322-3.0802.881-.5353.3274-1.0171.7361-1.4198 1.209-.4027-.4729-.8845-.8816-1.4198-1.209-.9136-.559-1.983-.881-3.0802-.881-3.08 0-5.5 2.42-5.5 5.5 0 3.7769 3.3944 6.8549 8.5373 11.5185zm1.5571-1.4721c2.6146-2.376 4.6222-4.2047 6.0006-5.8911C19.4635 10.8331 20 9.5581 20 8.325c0-1.9754-1.5246-3.5-3.5-3.5-1.1344 0-2.2545.5379-2.9773 1.3867L12 7.9998l-1.5227-1.7881C9.7545 5.3629 8.6344 4.825 7.5 4.825c-1.9754 0-3.5 1.5246-3.5 3.5 0 1.233.5365 2.5079 1.8918 4.165 1.3784 1.6851 3.3864 3.5119 6.0017 5.8834l.0029.0026.1087.099.0998-.0901z",
      clipRule: "evenodd"
    }
  ),
  "Heart"
), r1 = e(
  /* @__PURE__ */ l(
    "path",
    {
      fill: "currentColor",
      d: "m12 21.35-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54z"
    }
  ),
  "HeartFilled"
), d1 = e(
  /* @__PURE__ */ l(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M2 12C2 6.48 6.48 2 12 2s10 4.48 10 10-4.48 10-10 10S2 17.52 2 12m11 4v2h-2v-2zm-1 4c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8M8 10c0-2.21 1.79-4 4-4s4 1.79 4 4c0 1.2829-.79 1.9733-1.5592 2.6455C13.711 13.2833 13 13.9046 13 15h-2c0-1.8213.9421-2.5434 1.7704-3.1783C13.4202 11.3236 14 10.8792 14 10c0-1.1-.9-2-2-2s-2 .9-2 2z",
      clipRule: "evenodd"
    }
  ),
  "Help"
), v1 = e(
  /* @__PURE__ */ l(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "m3.0672 5.4127.3776 1.4095q.165-.2725.3463-.5332A10 10 0 1 1 2 12h1.9967a8.0031 8.0031 0 0 0 12.7375 6.4528 8.003 8.003 0 0 0 2.1656-10.508 8.0034 8.0034 0 0 0-13.8197.0344l1.661-.4451.5177 1.9318L2.4293 10.76l-1.294-4.8297zM12.75 7h-1.5v5.3107l4.2197 4.2196 1.0606-1.0606-3.7803-3.7804z",
      clipRule: "evenodd"
    }
  ),
  "History"
), h1 = e(
  /* @__PURE__ */ l(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "m22.69 18.37 1.14-1-1-1.73-1.45.49q-.48-.405-1.08-.63L20 14h-2l-.3 1.49q-.6.225-1.08.63l-1.45-.49-1 1.73 1.14 1c-.08.5-.08.76 0 1.26l-1.14 1 1 1.73 1.45-.49q.48.405 1.08.63L18 24h2l.3-1.49q.6-.225 1.08-.63l1.45.49 1-1.73-1.14-1c.08-.51.08-.77 0-1.27M19 21c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2M11 7v5.41l2.36 2.36 1.04-1.79-1.4-1.39V7zm10 5c0-4.97-4.03-9-9-9-2.83 0-5.35 1.32-7 3.36V4H3v6h6V8H6.26C7.53 6.19 9.63 5 12 5c3.86 0 7 3.14 7 7zm-10.14 6.91c-2.99-.49-5.35-2.9-5.78-5.91H3.06c.5 4.5 4.31 8 8.94 8h.07z",
      clipRule: "evenodd"
    }
  ),
  "HistoryManage"
), t1 = e(
  /* @__PURE__ */ l(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "m15.1 19.37 1 1.74c-.96.44-2.01.73-3.1.84v-2.02c.74-.09 1.44-.28 2.1-.56M4.07 13H2.05c.11 1.1.4 2.14.84 3.1l1.74-1c-.28-.66-.47-1.36-.56-2.1M15.1 4.63l1-1.74c-.96-.44-2-.73-3.1-.84v2.02c.74.09 1.44.28 2.1.56M19.93 11h2.02c-.11-1.1-.4-2.14-.84-3.1l-1.74 1c.28.66.47 1.36.56 2.1M8.9 19.37l-1 1.74c.96.44 2.01.73 3.1.84v-2.02c-.74-.09-1.44-.28-2.1-.56M11 4.07V2.05c-1.1.11-2.14.4-3.1.84l1 1.74c.66-.28 1.36-.47 2.1-.56m7.36 3.1 1.74-1.01c-.63-.87-1.4-1.64-2.27-2.27l-1.01 1.74c.59.45 1.1.96 1.54 1.54M4.63 8.9l-1.74-1c-.44.96-.73 2-.84 3.1h2.02c.09-.74.28-1.44.56-2.1m15.3 4.1c-.09.74-.28 1.44-.56 2.1l1.74 1c.44-.96.73-2.01.84-3.1zm-3.1 5.36 1.01 1.74c.87-.63 1.64-1.4 2.27-2.27l-1.74-1.01c-.45.59-.96 1.1-1.54 1.54M7.17 5.64l-1-1.75c-.88.64-1.64 1.4-2.27 2.28l1.74 1.01c.44-.59.95-1.1 1.53-1.54M5.64 16.83l-1.74 1c.63.87 1.4 1.64 2.27 2.27l1.01-1.74c-.59-.44-1.1-.95-1.54-1.53M13 7h-2v5.41l4.29 4.29 1.41-1.41-3.7-3.7z",
      clipRule: "evenodd"
    }
  ),
  "HistoryToggleOff"
), i1 = e(
  /* @__PURE__ */ l(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M12 4.5 18 9v11h-3v-4H9v4H6V9zM11 20h2v-2h-2zm-2 2H4V8l8-6 8 6v14z",
      clipRule: "evenodd"
    }
  ),
  "Home"
), u1 = e(
  [
    /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        d: "M1.9935 12 12 22.0065l3.1049-3.1048-1.4142-1.4142L12 19.1781 4.822 12 12 4.822l1.6907 1.6906 1.4142-1.4142L12 1.9935z"
      },
      "0"
    ),
    /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M19.5862 12.0703c0 .88-.26 1.69-.7 2.39l3.12 3.11-1.42 1.42-3.12-3.12c-.69.44-1.51.7-2.39.7-2.48 0-4.49-2.01-4.49-4.5s2.01-4.5 4.5-4.5 4.5 2.01 4.5 4.5m-7 0c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5-1.12-2.5-2.5-2.5-2.5 1.12-2.5 2.5",
        clipRule: "evenodd"
      },
      "1"
    )
  ],
  "InspectComponent"
), s1 = e(
  /* @__PURE__ */ l(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "m19.2334 8.476 2.0565-2.186-3.5142-3.5143-8.9547 8.9547a5 5 0 0 0-1.8406-.1451 4.9996 4.9996 0 0 0-4.4642 5.1052 5 5 0 1 0 9.8312-1.4154l3.307-3.307 2.1213 2.1213 3.5355-3.5355zm-9.0472 6.207-.0067-.0084 5.4749-5.535 2.1213 2.1214.7071-.7071-2.0352-2.0353 2.0565-2.186-.7284-.7285-8.2748 8.2749-.0514.0692-.0006-.0005a3.25 3.25 0 0 0-2.2814-.6204 3.248 3.248 0 0 0-2.8999 3.3163A3.2484 3.2484 0 0 0 7.3409 19.8a3.248 3.248 0 0 0 2.8328-5.1082zm-1.9565 2.5884c-.3905.3905-1.0236.3905-1.4142 0s-.3905-1.0237 0-1.4142c.3906-.3906 1.0237-.3906 1.4142 0 .3906.3905.3906 1.0236 0 1.4142",
      clipRule: "evenodd"
    }
  ),
  "Key"
), p1 = e(
  /* @__PURE__ */ l(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "m21.8869 9-9.8868-6.1793L2.1133 9 12 15.1792zm-9.8868 3.8207L5.8869 9 12 5.1792 18.1133 9zM5.8869 15l1.0456-.6535-1.8772-1.1852L2.1133 15 12 21.1792 21.8869 15l-2.9412-1.8382-1.8833 1.1814L18.1133 15l-6.1132 3.8207z",
      clipRule: "evenodd"
    }
  ),
  "Layers"
), a1 = e(
  /* @__PURE__ */ l(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M21 9h-6.31l.95-4.57.03-.32c0-.41-.17-.79-.44-1.06L14.17 2 7.59 8.59C7.22 8.95 7 9.45 7 10v12h11c.83 0 1.54-.5 1.84-1.22l3.02-7.05c.09-.23.14-.47.14-.73V9zm0 4-3 7H9V10l4.34-4.34L12.23 11H21zM5 10H2v12h3z",
      clipRule: "evenodd"
    }
  ),
  "Like"
), z1 = e(
  [
    /* @__PURE__ */ l(
      "path",
      {
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        d: "M2 12C2 6.4772 6.4772 2 12 2s10 4.4772 10 10-4.4772 10-10 10S2 17.5228 2 12Z"
      },
      "0"
    ),
    /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M16.8573 10h-3.6057l.5428-2.6114.0172-.1829a.86.86 0 0 0-.2515-.6057l-.6057-.6-3.76 3.7657c-.2114.2057-.3371.4914-.3371.8057v6.8572h6.2857c.4743 0 .88-.2857 1.0514-.6972l1.7257-4.0285a1.13 1.13 0 0 0 .08-.4172V10zm-.0001 2.2857-1.7143 4h-5.1428v-5.7143l2.48-2.48-.6343 3.0515h5.0114zm-9.143-1.7143H6v6.8572h1.7143z",
        clipRule: "evenodd"
      },
      "1"
    )
  ],
  "LikeCircle"
), f1 = e(
  /* @__PURE__ */ l(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M17 7h-4v2h4c1.65 0 3 1.35 3 3s-1.35 3-3 3h-4v2h4c2.76 0 5-2.24 5-5s-2.24-5-5-5m-6 8H7c-1.65 0-3-1.35-3-3s1.35-3 3-3h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4zm-3-4h8v2H8z",
      clipRule: "evenodd"
    }
  ),
  "Link"
), C1 = e(
  /* @__PURE__ */ l(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M8 11h8v2H8zm12.1 1H22c0-2.76-2.24-5-5-5h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1M19 12h-2v3h-3v2h3v3h2v-3h3v-2h-3z",
      clipRule: "evenodd"
    }
  ),
  "LinkAdd"
), m1 = e(
  /* @__PURE__ */ l(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M14.39 11 16 12.61V11zM17 7h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1 0 1.27-.77 2.37-1.87 2.84l1.4 1.4C21.05 15.36 22 13.79 22 12c0-2.76-2.24-5-5-5M2 4.27l3.11 3.11C3.29 8.12 2 9.91 2 12c0 2.76 2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1 0-1.59 1.21-2.9 2.76-3.07L8.73 11H8v2h2.73L13 15.27V17h1.73l4.01 4.01 1.41-1.41L3.41 2.86z",
      clipRule: "evenodd"
    }
  ),
  "LinkOff"
), M1 = e(
  /* @__PURE__ */ l("path", { fill: "currentColor", d: "M3 5h18v2H3zm0 4h18v2H3zm0 4h18v2H3zm0 4h18v2H3z" }),
  "ListView"
), R1 = e(
  /* @__PURE__ */ l(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M12 2C8.14 2 5 5.14 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.86-3.14-7-7-7M7 9c0-2.76 2.24-5 5-5s5 2.24 5 5c0 2.88-2.88 7.19-5 9.88C9.92 16.21 7 11.85 7 9m5 1c1.1046 0 2-.8954 2-2s-.8954-2-2-2-2 .8954-2 2 .8954 2 2 2",
      clipRule: "evenodd"
    }
  ),
  "LocationTag"
), H1 = e(
  [
    /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7.1885 4.2907C8.1239 2.9915 9.674 2 12 2s3.8761.9915 4.8115 2.2907c.6299.8749.9607 1.8576 1.1022 2.7093H22v15H2V7h4.0863c.1415-.8517.4723-1.8344 1.1022-2.7093m8 1.1686c.3481.4835.5651 1.033.6862 1.5407H8.1253c.121-.5077.3381-1.0572.6862-1.5407C9.3761 4.6751 10.326 4 12 4s2.6239.6751 3.1885 1.4593M4 9v11h16V9zm8 6c1.1046 0 2-.8954 2-2s-.8954-2-2-2-2 .8954-2 2 .8954 2 2 2",
        clipRule: "evenodd"
      },
      "0"
    ),
    /* @__PURE__ */ l("path", { fill: "currentColor", d: "M11 14h2v4h-2z" }, "1")
  ],
  "Lock"
), V1 = e(
  /* @__PURE__ */ l(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M14.5 5.5714 9.5 3 2 5.5714V21l2-.6857 5.5-1.8857L14.5 21l7.5-2.5714V3l-2 .6857zm1.5 1.6v11.2L20 17V5.8zM14 18.494V7.5633l-.4147-.2133L11 6.0204V16.951zM4 7l5-1.7143v11.2l-.1486.051L4 18.2z",
      clipRule: "evenodd"
    }
  ),
  "Map"
), L1 = e(
  /* @__PURE__ */ l(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h8v-2H4V8l8 5 8-5v5h2V6c0-1.1-.9-2-2-2m-8 7L4 6h16zm5.34 11-3.54-3.54 1.41-1.41 2.12 2.12 4.24-4.24L23 16.34z",
      clipRule: "evenodd"
    }
  ),
  "MarkEmailRead"
), S1 = e(
  /* @__PURE__ */ l(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "m15.9081 5.9869 1.1585-1.1585 2.105 2.105L6.9334 19.1716l-2.105-2.105 1.2128-1.2128 1.2842 1.2841 1.4095-1.4096-1.2841-1.2841 2.819-2.819 1.284 1.284 1.4096-1.4095-1.2841-1.284 2.8193-2.8193 1.2841 1.2842 1.4096-1.4095zM2 17.0666l1.4142-1.4142L15.6524 3.4142 17.0666 2l1.4142 1.4142 2.105 2.105L22 6.9334l-1.4142 1.4142L8.3476 20.5858 6.9334 22l-1.4142-1.4142-2.105-2.105z",
      clipRule: "evenodd"
    }
  ),
  "Measure"
), A1 = e(/* @__PURE__ */ l("path", { fill: "currentColor", d: "M21 11v2H3v-2z" }), "Minus"), g1 = e(
  /* @__PURE__ */ l(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M4 8V6h16v2zm0 4v6h16v-6zM2 5c0-.5523.4477-1 1-1h18c.5523 0 1 .4477 1 1v14c0 .5523-.4477 1-1 1H3c-.5523 0-1-.4477-1-1zm14 9h2v2h-2z",
      clipRule: "evenodd"
    }
  ),
  "Money"
), y1 = e(
  /* @__PURE__ */ l(
    "path",
    {
      fill: "currentColor",
      d: "M14 13q-1.25 0-2.125-.875T11 10t.875-2.125T14 7t2.125.875T17 10t-.875 2.125T14 13m-7 3q-.825 0-1.412-.588Q5 14.825 5 14V6q0-.825.588-1.412Q6.175 4 7 4h14q.825 0 1.413.588Q23 5.175 23 6v8q0 .825-.587 1.412Q21.825 16 21 16zm2-2h10q0-.825.587-1.413Q20.175 12 21 12V8q-.825 0-1.413-.588Q19 6.825 19 6H9q0 .825-.588 1.412Q7.825 8 7 8v4q.825 0 1.412.587Q9 13.175 9 14m11 6H3q-.825 0-1.412-.587Q1 18.825 1 18V7h2v11h17zM7 14V6z"
    }
  ),
  "MoneyNotes"
), P1 = e(
  /* @__PURE__ */ l(
    "path",
    {
      fill: "currentColor",
      d: "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2"
    }
  ),
  "MoreHorizontal"
), k1 = e(
  /* @__PURE__ */ l(
    "path",
    {
      fill: "currentColor",
      d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2m0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2"
    }
  ),
  "MoreVertical"
), w1 = e(
  /* @__PURE__ */ l(
    "path",
    {
      fill: "currentColor",
      d: "M17.0001 12h2l-7-10-6.95 10h1.95l-3.9 6h6.92v4h3.95v-4h7.03zm-10.21 4 3.9-6h-1.81l3.13-4.5 3.15 4.5h-1.9l4 6z"
    }
  ),
  "ParkOutlined"
), q1 = e(
  [
    /* @__PURE__ */ o("g", { fill: "currentColor", fillRule: "evenodd", clipRule: "evenodd", children: [
      /* @__PURE__ */ l("path", { d: "m17.7969 1.9979 4.2052 4.2051-3.311 3.4938a.07.07 0 0 0-.005.0172c-.004.0223-.0039.0589.0101.1017.8159 2.4802.1778 5.2098-1.8373 7.2248-.9739.9739-2.2956 1.6836-3.6564 2.2097-1.3713.5301-2.8498.8992-4.1969 1.1568-1.3502.2582-2.5896.4084-3.4907.4942a35 35 0 0 1-1.0765.0862 24 24 0 0 1-.299.0171l-.0805.0038-.022.001-.0062.0002-.002.0001c-.0002 0-.001 0-.0391-.9993-.9993-.038-.9993-.0382-.9993-.0385l.0001-.0025.0003-.0063.001-.0219.0037-.0806a23 23 0 0 1 .0171-.299 35 35 0 0 1 .0863-1.0764c.0857-.9011.236-2.1406.4942-3.4908.2576-1.3471.6266-2.8256 1.1568-4.1969.526-1.3607 1.2358-2.6825 2.2096-3.6564 2.015-2.015 4.7446-2.6531 7.2248-1.8373.0429.014.0794.0142.1017.0101a.06.06 0 0 0 .0172-.005zM14.3043 5.308l-.0012.0007ZM3.9896 20.0103l-.9993-.0385-.041 1.0789 1.0783-.0411zm1.0764-1.0764a44 44 0 0 0 .2593-.0237c.8573-.0816 2.032-.2242 3.3047-.4676 1.2758-.244 2.629-.5854 3.8514-1.0579 1.2329-.4766 2.2667-1.0618 2.9633-1.7584 1.5032-1.5032 1.9222-3.4512 1.3517-5.1857-.2222-.6755-.1329-1.5118.4421-2.1185l1.9726-2.0816-1.4517-1.4517-2.0816 1.9726c-.6067.575-1.4429.6644-2.1185.4421-1.7345-.5705-3.6825-.1514-5.1857 1.3517-.6966.6967-1.2818 1.7305-1.7584 2.9634-.4725 1.2223-.8138 2.5755-1.0578 3.8514-.2434 1.2727-.386 2.4473-.4676 3.3046a35 35 0 0 0-.0238.2593" }),
      /* @__PURE__ */ l("path", { d: "M12 14c1.1046 0 2-.8954 2-2s-.8954-2-2-2-2 .8954-2 2c0 .2772.0564.5411.1583.7811l-6.6886 6.6886 1.0607 1.0606 6.6886-6.6885c.2399.1018.5039.1582.781.1582" })
    ] }, "0"),
    /* @__PURE__ */ l("defs", {}, "1")
  ],
  "Pen"
), D1 = e(
  /* @__PURE__ */ l(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M16.9599 3.29c.19-.19.45-.29.7-.29.26 0 .51.09.71.29l2.34 2.34c.39.39.39 1.02 0 1.41l-1.83 1.83-3.75-3.75zM5 18.9999v-.9215l9.06-9.06.9216.9215-9.06 9.06zm-2-1.75 9.6458-9.6457L14.06 6.1899l1.4142 1.4143.9216.9215L17.81 9.94l-1.4142 1.4143L6.75 20.9999H3z",
      clipRule: "evenodd"
    }
  ),
  "Pencil"
), F1 = e(
  /* @__PURE__ */ l(
    "path",
    {
      fill: "currentColor",
      d: "M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5s-3 1.34-3 3 1.34 3 3 3m-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5 5 6.34 5 8s1.34 3 3 3m0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5m8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5"
    }
  ),
  "People"
), T1 = e(
  /* @__PURE__ */ l(
    "path",
    {
      fill: "currentColor",
      d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4m0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4"
    }
  ),
  "Person"
), U1 = e(
  /* @__PURE__ */ l(
    "path",
    {
      fill: "currentColor",
      d: "M15 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4m-9-2V7H4v3H1v2h3v3h2v-3h3v-2zm9 4c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4"
    }
  ),
  "PersonAdd"
), b1 = e(
  /* @__PURE__ */ l(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M4 18v-.65c0-.34.16-.66.41-.81C6.1 15.53 8.03 15 10 15c.03 0 .05 0 .08.01.1-.7.3-1.37.59-1.98-.22-.02-.44-.03-.67-.03-2.42 0-4.68.67-6.61 1.82-.88.52-1.39 1.5-1.39 2.53V20h9.26c-.42-.6-.75-1.28-.97-2zm6-6c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4m0-6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2m10.75 10c0-.22-.03-.42-.06-.63l1.14-1.01-1-1.73-1.45.49q-.48-.405-1.08-.63L18 11h-2l-.3 1.49q-.6.225-1.08.63l-1.45-.49-1 1.73 1.14 1.01c-.03.21-.06.41-.06.63s.03.42.06.63l-1.14 1.01 1 1.73 1.45-.49q.48.405 1.08.63L16 21h2l.3-1.49q.6-.225 1.08-.63l1.45.49 1-1.73-1.14-1.01c.03-.21.06-.41.06-.63M17 18c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2",
      clipRule: "evenodd"
    }
  ),
  "PersonManage"
), E1 = e(
  /* @__PURE__ */ l(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "m20 17.17-3.37-3.38c.64.22 1.23.48 1.77.76.97.51 1.58 1.52 1.6 2.62m1.19 4.02-1.41 1.41-2.61-2.6H4v-2.78c0-1.12.61-2.15 1.61-2.66 1.29-.66 2.87-1.22 4.67-1.45L1.39 4.22 2.8 2.81zM15.17 18l-3-3H12c-2.37 0-4.29.73-5.48 1.34-.32.16-.52.5-.52.88V18zM12 6c1.1 0 2 .9 2 2 0 .86-.54 1.59-1.3 1.87l1.48 1.48C15.28 10.64 16 9.4 16 8c0-2.21-1.79-4-4-4-1.4 0-2.64.72-3.35 1.82l1.48 1.48C10.41 6.54 11.14 6 12 6",
      clipRule: "evenodd"
    }
  ),
  "PersonOff"
), O1 = e(
  /* @__PURE__ */ l(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M20 12c0 4.4183-3.5817 8-8 8s-8-3.5817-8-8 3.5817-8 8-8 8 3.5817 8 8m2 0c0 5.5228-4.4772 10-10 10S2 17.5228 2 12 6.4772 2 12 2s10 4.4772 10 10m-3.9883 0L8.75 6.7076v10.5848zm-3.0234 0L10.25 14.7076V9.2924z",
      clipRule: "evenodd"
    }
  ),
  "Play"
), Q1 = e(/* @__PURE__ */ l("path", { fill: "currentColor", d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6z" }), "Plus"), x1 = e(
  /* @__PURE__ */ l(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M12 15c1.6569 0 3-1.3431 3-3s-1.3431-3-3-3-3 1.3431-3 3 1.3431 3 3 3m0 2c2.7614 0 5-2.2386 5-5s-2.2386-5-5-5-5 2.2386-5 5 2.2386 5 5 5",
      clipRule: "evenodd"
    }
  ),
  "Point"
), I1 = e(
  [
    /* @__PURE__ */ l("g", { children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m2.3974 3.2246 19.7754 7.1026-8.1283 4.5445L9.5 23zm7.5003 14.9659 2.6772-4.7884 4.7883-2.6772L5.7135 6.5407z",
        clipRule: "evenodd"
      }
    ) }, "0"),
    /* @__PURE__ */ l("defs", {}, "1")
  ],
  "Pointer"
), B1 = e(
  /* @__PURE__ */ l("path", { fill: "currentColor", fillRule: "evenodd", d: "M3 3v18h18v-9zm2 3.236V19h14v-5.7639z", clipRule: "evenodd" }),
  "Polygon"
), G1 = e(
  /* @__PURE__ */ l(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M8 5C6.3431 5 5 6.3431 5 8v11H3V8c0-2.7614 2.2386-5 5-5s5 2.2386 5 5v8c0 1.6569 1.3431 3 3 3s3-1.3431 3-3V5h2v11c0 2.7614-2.2386 5-5 5s-5-2.2386-5-5V8c0-1.6569-1.3431-3-3-3",
      clipRule: "evenodd"
    }
  ),
  "Polyline"
), W1 = e(
  /* @__PURE__ */ l(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M16 4H8v4h8zm2 4V2H6v6H2v10h4v4.5h12V18h4V8zm1 4c0 .5523-.4477 1-1 1s-1-.4477-1-1 .4477-1 1-1 1 .4477 1 1M6 14h12v2h2v-6H4v6h2zm2 4v-2h8v4.5H8z",
      clipRule: "evenodd"
    }
  ),
  "Print"
), Z1 = e(
  [
    /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M17 8.5008h3v14H4v-14h3v-2c0-2.92 2.51-5.26 5.49-4.98 2.6.25 4.51 2.58 4.51 5.19zm-8-2v2h6v-2c0-1.66-1.34-3-3-3s-3 1.34-3 3M18 20.5v-10H6v10z",
        clipRule: "evenodd"
      },
      "0"
    ),
    /* @__PURE__ */ l("circle", { cx: "12", cy: "15.5", r: "2", fill: "currentColor" }, "1")
  ],
  "PrivateDesign"
), N1 = e(
  /* @__PURE__ */ l("path", { fill: "currentColor", fillRule: "evenodd", d: "M19 5v14H5V5zM3 3h18v18H3z", clipRule: "evenodd" }),
  "Rectangle"
), j1 = e(
  /* @__PURE__ */ l(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M12 4.8284 19.1716 12 12 19.1716 4.8284 12zM12 2l1.4142 1.4142 7.1716 7.1716L22 12l-1.4142 1.4142-7.1716 7.1716L12 22l-1.4142-1.4142-7.1716-7.1716L2 12l1.4142-1.4142 7.1716-7.1716zm-1.25 8.75L12 8l1.25 2.75L16 12l-2.75 1.25L12 16l-1.25-2.75L8 12z",
      clipRule: "evenodd"
    }
  ),
  "ReferenceComponent"
), K1 = e(
  /* @__PURE__ */ l(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M11 4v9h7v7h-6.8922l-.9069 2H20V11.5L12 2H4v13.8055L6 14.9V4zM8.909 20h.0028l-.9069 2H7.996l-.9062-2h.0011l-.3409-.75-.75-.3409v.0025l-2-.9103v-.0004l.001-.0004L4 18l2.75-1.25L8 14l1.25 2.75L12 18l-2.75 1.25zm8.0553-9L13 6.2924V11z",
      clipRule: "evenodd"
    }
  ),
  "ReferenceDesign"
), J1 = e(
  /* @__PURE__ */ l(
    "path",
    {
      fill: "currentColor",
      d: "m19 8-4 4h3c0 3.31-2.69 6-6 6-1.01 0-1.97-.25-2.8-.7l-1.46 1.46C8.97 19.54 10.43 20 12 20c4.42 0 8-3.58 8-8h3zM6 12c0-3.31 2.69-6 6-6 1.01 0 1.97.25 2.8.7l1.46-1.46C15.03 4.46 13.57 4 12 4c-4.42 0-8 3.58-8 8H1l4 4 4-4z"
    }
  ),
  "Refresh"
), X1 = e(
  /* @__PURE__ */ l(
    "path",
    {
      fill: "currentColor",
      d: "M12 5V1L7 6l5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6H4c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8"
    }
  ),
  "Replay"
), Y1 = e(
  /* @__PURE__ */ l(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "m13.9852 13.7428 5.0859-5.086-2.8284-2.8284-5.086 5.0859zm7.2072-4.3788L10.6569 19.8995h-5.657l-2.1563-2.0507c-.4074-.3874-.4155-1.0343-.018-1.4317l12.71-12.71c.3905-.3905 1.0236-.3905 1.4142 0l4.2426 4.2426c.3905.3906.3905 1.0237 0 1.4143",
      clipRule: "evenodd"
    }
  ),
  "Rubber"
), _1 = e(
  /* @__PURE__ */ l(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M14 9c0 2.7614-2.2386 5-5 5s-5-2.2386-5-5 2.2386-5 5-5 5 2.2386 5 5m-.8077 5.6063C12.0237 15.4816 10.5724 16 9 16c-3.866 0-7-3.134-7-7s3.134-7 7-7 7 3.134 7 7c0 1.5723-.5184 3.0235-1.3936 4.1921l6.4648 6.4647-1.4142 1.4142z",
      clipRule: "evenodd"
    }
  ),
  "Search"
), $1 = e(/* @__PURE__ */ l("path", { fill: "currentColor", d: "M9 21 3 4l17 6-6 3 5 5-2 2-5-5z" }), "Select"), l2 = e(
  /* @__PURE__ */ l(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "m4.01 6.03 7.51 3.22-7.52-1zm7.5 8.72L4 17.97v-2.22zM2.01 3 2 10l15 2-15 2 .01 7L23 12z",
      clipRule: "evenodd"
    }
  ),
  "Send"
), e2 = e(
  /* @__PURE__ */ o("g", { fill: "currentColor", children: [
    /* @__PURE__ */ l(
      "path",
      {
        fillRule: "evenodd",
        d: "M16.5 9c-.42 0-.83.04-1.24.11L1.01 3 1 10l10.06 1.34c-.42.44-.78.93-1.09 1.46L1 14l.01 7 8.07-3.46C9.59 21.19 12.71 24 16.5 24c4.14 0 7.5-3.36 7.5-7.5S20.64 9 16.5 9M3 8.25l.01-2.22 7.51 3.22zm6.1 7.11L3 17.97v-2.22l6.17-.82c-.03.14-.05.28-.07.43M16.5 22c-3.03 0-5.5-2.47-5.5-5.5s2.47-5.5 5.5-5.5 5.5 2.47 5.5 5.5-2.47 5.5-5.5 5.5",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ l("path", { d: "m18.27 14.03-1.77 1.76-1.77-1.76-.7.7 1.76 1.77-1.76 1.77.7.7 1.77-1.76 1.77 1.76.7-.7-1.76-1.77 1.76-1.77z" })
  ] }),
  "SendCancel"
), o2 = e(
  /* @__PURE__ */ l(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M19.2293 12c0 .34-.03.66-.07.98l2.11 1.65c.19.15.24.42.12.64l-2 3.46c-.09.16-.26.25-.43.25q-.09 0-.18-.03l-2.49-1c-.52.39-1.08.73-1.69.98l-.38 2.65c-.03.24-.24.42-.49.42h-4c-.25 0-.46-.18-.49-.42l-.38-2.65c-.61-.25-1.17-.58-1.69-.98l-2.49 1c-.05.02-.11.03-.17.03-.18 0-.35-.09-.44-.25l-2-3.46c-.12-.22-.07-.49.12-.64l2.11-1.65c-.04-.32-.07-.65-.07-.98s.03-.66.07-.98l-2.11-1.65c-.19-.15-.25-.42-.12-.64l2-3.46c.09-.16.26-.25.43-.25q.09 0 .18.03l2.49 1c.52-.39 1.08-.73 1.69-.98l.38-2.65c.03-.24.24-.42.49-.42h4c.25 0 .46.18.49.42l.38 2.65c.61.25 1.17.58 1.69.98l2.49-1c.05-.02.11-.03.17-.03.18 0 .35.09.44.25l2 3.46c.12.22.07.49-.12.64l-2.11 1.65c.04.32.07.64.07.98m-2 0c0-.21-.01-.42-.05-.73l-.14-1.13.89-.7 1.07-.85-.7-1.21-1.27.51-1.06.43-.91-.7c-.4-.3-.8-.53-1.23-.71l-1.06-.43-.16-1.13-.19-1.35h-1.39l-.2 1.35-.16 1.13-1.06.43c-.41.17-.82.41-1.25.73l-.9.68-1.04-.42-1.27-.51-.7 1.21 1.08.84.89.7-.14 1.13c-.03.3-.05.53-.05.73s.02.43.05.74l.14 1.13-.89.7-1.08.84.7 1.21 1.27-.51 1.06-.43.91.7c.4.3.8.53 1.23.71l1.06.43.16 1.13.19 1.35h1.4l.2-1.35.16-1.13 1.06-.43c.41-.17.82-.41 1.25-.73l.9-.68 1.04.42 1.27.51.7-1.21-1.08-.84-.89-.7.14-1.13c.03-.3.05-.52.05-.73m-5.5-4c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4m-2 4c0 1.1.9 2 2 2s2-.9 2-2-.9-2-2-2-2 .9-2 2",
      clipRule: "evenodd"
    }
  ),
  "Settings"
), c2 = e(
  /* @__PURE__ */ l(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M18 8c1.1046 0 2-.8954 2-2s-.8954-2-2-2-2 .8954-2 2 .8954 2 2 2m0 2c2.2091 0 4-1.7909 4-4s-1.7909-4-4-4-4 1.7909-4 4c0 .2874.0303.5678.0879.838l-5.071 2.5355C8.2836 8.5319 7.204 8 6 8c-2.2091 0-4 1.7909-4 4s1.7909 4 4 4c1.204 0 2.2836-.5319 3.017-1.3735l5.0709 2.5355A4 4 0 0 0 14 18c0 2.2091 1.7909 4 4 4s4-1.7909 4-4-1.7909-4-4-4c-1.2039 0-2.2836.5319-3.0169 1.3735l-5.071-2.5355A4 4 0 0 0 10 12c0-.2874-.0303-.5678-.088-.838l5.0711-2.5355C15.7164 9.4681 16.7961 10 18 10M6 14c1.1046 0 2-.8954 2-2s-.8954-2-2-2-2 .8954-2 2 .8954 2 2 2m14 4c0 1.1046-.8954 2-2 2s-2-.8954-2-2 .8954-2 2-2 2 .8954 2 2",
      clipRule: "evenodd"
    }
  ),
  "Share"
), n2 = e(
  /* @__PURE__ */ l(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M10 5H4v2h6zM2 3v18h20V7H12V3zm2 16V9h16v10zm12.0017-4.0051h2.0028v-1.9917h-2.0028v-2.0129l-1.9998-.0001v2.013h-2.0024l.0003 1.9917h2.0021v1.9953h1.9998z",
      clipRule: "evenodd"
    }
  ),
  "SmartFolder"
), r2 = e(
  [
    /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6 7c.5523 0 1-.4477 1-1s-.4477-1-1-1-1 .4477-1 1 .4477 1 1 1m0 2c1.6569 0 3-1.3431 3-3S7.6569 3 6 3 3 4.3431 3 6s1.3431 3 3 3m12 0c.5523 0 1-.4477 1-1s-.4477-1-1-1-1 .4477-1 1 .4477 1 1 1m0 2c1.6569 0 3-1.3431 3-3s-1.3431-3-3-3-3 1.3431-3 3 1.3431 3 3 3M8 19c.5523 0 1-.4477 1-1s-.4477-1-1-1-1 .4477-1 1 .4477 1 1 1m0 2c1.6569 0 3-1.3431 3-3s-1.3431-3-3-3-3 1.3431-3 3 1.3431 3 3 3",
        clipRule: "evenodd"
      },
      "0"
    ),
    /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m15.876 8.4923-8-1 .248-1.9846 8 1zM6.5077 16.124l-1-8 1.9846-.248 1 8z",
        clipRule: "evenodd"
      },
      "1"
    )
  ],
  "Snapping"
), d2 = e(
  /* @__PURE__ */ l(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M3 3h18v18h-5.4444v-2H19V5H5v14h3.4444v2H3zm9.9999 12v2.5h-2V15c0-.9894.497-1.5206 1.4761-2.064 0 0 .4137-.225.5238-.2886C13.736 12.2222 14 11.8564 14 11c0-1.1046-.8954-2-2-2s-2 .8954-2 2H8c0-2.2091 1.7909-4 4-4s4 1.7909 4 4c0 1.6604-.6978 2.6272-1.9998 3.3793-.1365.0788-.5738.3166-.5537.3055-.4021.2231-.4466.2706-.4466.3152M13 21v-2h-2v2z",
      clipRule: "evenodd"
    }
  ),
  "SpatialQuery"
), v2 = e(
  /* @__PURE__ */ l(
    "path",
    {
      fill: "currentColor",
      d: "m22 9.74-7.19-.62L12 2.5 9.19 9.13 2 9.74l5.46 4.73-1.64 7.03L12 17.77l6.18 3.73-1.63-7.03zM12 15.9l-3.76 2.27 1-4.28-3.32-2.88 4.38-.38L12 6.6l1.71 4.04 4.38.38-3.32 2.88 1 4.28z"
    }
  ),
  "Star"
), h2 = e(
  /* @__PURE__ */ l(
    "path",
    {
      fill: "currentColor",
      d: "m12 17.77 6.18 3.73-1.64-7.03L22 9.74l-7.19-.61L12 2.5 9.19 9.13 2 9.74l5.46 4.73-1.64 7.03z"
    }
  ),
  "StarFilled"
), t2 = e(
  /* @__PURE__ */ l(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M11 5c0 .549.451 1 1 1s1-.451 1-1-.451-1-1-1-1 .451-1 1M9 5c0 1.6536 1.3464 3 3 3s3-1.3464 3-3-1.3464-3-3-3-3 1.3464-3 3m6 11v-2h2l-.4-2-.6-3H8l-.6 3-.4 2h2v5h6zm-2 1v-5h1.5604l-.2-1H9.6396l-.2 1H11v5zm7.0176.8922q.0005-.0013.0002-.0013a.04.04 0 0 0-.0045.0104.1.1 0 0 0 .0043-.0091M19.9407 18a1.5 1.5 0 0 0-.1008-.1039c-.2611-.2469-.7462-.5614-1.5116-.8676-.3963-.1585-.8413-.3043-1.3283-.4332v-2.0602c2.989.6916 5 1.9843 5 3.4649 0 2.2091-4.4772 4-10 4S2 20.2091 2 18c0-1.4806 2.011-2.7733 5-3.4649v2.0602c-.487.1289-.932.2747-1.3283.4332-.7654.3062-1.2505.6207-1.5116.8676A1.5 1.5 0 0 0 4.0593 18a1.5 1.5 0 0 0 .1008.1039c.261.2469.7462.5614 1.5116.8676C7.1914 19.5793 9.428 20 12 20s4.8086-.4207 6.3283-1.0285c.7654-.3062 1.2505-.6207 1.5116-.8676A1.5 1.5 0 0 0 19.9407 18m-15.9585-.1091a.04.04 0 0 1 .0045.0104.04.04 0 0 1-.0045-.0104m0 .2182a.04.04 0 0 1 .0045-.0104.04.04 0 0 1-.0045.0104m16.0311-.0104c.0037.0069.0049.0104.0045.0104a.04.04 0 0 1-.0045-.0104",
      clipRule: "evenodd"
    }
  ),
  "StreetView"
), i2 = e(
  /* @__PURE__ */ l(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M12 22c5.5228 0 10-4.4772 10-10S17.5228 2 12 2 2 6.4772 2 12s4.4772 10 10 10m-3.2425-7.1004-2.2014-2.2014 1.4142-1.4142 2.2014 2.2014 5.6568-5.6568 1.4143 1.4142-7.0711 7.071z",
      clipRule: "evenodd"
    }
  ),
  "SuccessFilled"
), u2 = e(
  [
    /* @__PURE__ */ l("g", { children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m18.3552 13.1804-4.4508 4.8217 1.4696 1.3566 6.6261-7.1783-6.6261-7.1783-1.4696 1.3566 4.4508 4.8217H5.6449l4.4508-4.8217L8.6261 5.002 2 12.1804l6.6261 7.1783 1.4696-1.3566-4.4508-4.8217z",
        clipRule: "evenodd"
      }
    ) }, "0"),
    /* @__PURE__ */ l("defs", {}, "1")
  ],
  "Swipe"
), s2 = e(
  [
    /* @__PURE__ */ l("circle", { cx: "16", cy: "8", r: "2", fill: "currentColor" }, "0"),
    /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m19.3202 11.0438-.2448-6.1192-6.1192-.2447L4.383 13.253l6.364 6.3639zM21 3l.3536 8.8388L10.747 22.4454l-9.1924-9.1923L12.1612 2.6465z",
        clipRule: "evenodd"
      },
      "1"
    )
  ],
  "Tag"
), p2 = e(
  /* @__PURE__ */ l("path", { fill: "currentColor", d: "m8.795 15.875-4.17-4.17-1.42 1.41 5.59 5.59 12-12-1.41-1.41z" }),
  "Tick"
), a2 = e(
  /* @__PURE__ */ l(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M5 5h4v4H5zm-2 6V3h8v8zm2 4h4v4H5zm-2 6v-8h8v8zm16-6h-4v4h4zm-6-2v8h8v-8zm2-8h4v4h-4zm-2 6V3h8v8z",
      clipRule: "evenodd"
    }
  ),
  "TileView"
), z2 = e(
  [
    /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 20c4.4183 0 8-3.5817 8-8s-3.5817-8-8-8-8 3.5817-8 8 3.5817 8 8 8m0 2c5.5228 0 10-4.4772 10-10S17.5228 2 12 2 2 6.4772 2 12s4.4772 10 10 10",
        clipRule: "evenodd"
      },
      "0"
    ),
    /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11.25 7h1.5v4.6893l3.7803 3.7804-1.0606 1.0606-4.2197-4.2196z",
        clipRule: "evenodd"
      },
      "1"
    )
  ],
  "Time"
), f2 = e(
  /* @__PURE__ */ l("path", { fill: "currentColor", fillRule: "evenodd", d: "M18 16h-8V4h8zM8 18h12V2H8zM6 8v12h10v2H4V8z", clipRule: "evenodd" }),
  "Undock"
), C2 = e(
  [
    /* @__PURE__ */ o("g", { fill: "currentColor", children: [
      /* @__PURE__ */ l("path", { d: "m14.2544 17.069 6.9305 6.9305 1.4142-1.4142-6.5649-6.565v-.9466h1.8594l.0034.0034h.1395l.0005-1.9951h-2.0028v-2.013h-1.9998v.0034l-.0005.1417.0005 1.8679h-.9386l-11.71-11.71-1.4141 1.4143 12.0605 12.0605v.0224l-.0004.2079h.2083l-.0034-.0034h.0224l1.7753 1.7753v.0224l-.0005.201h.2015l-.0034-.0034z" }),
      /* @__PURE__ */ l("path", { d: "M22.0603 19.2123v-12.13h-10v-4h-6.13l2 2h2.13v2h-.13l2.0001 2h8.1299v8.13zM6.2677 9.0823l-2-2h-.2074V6.875l-2-2v16.2074h16.2074l-2-2H4.0603v-10z" })
    ] }, "0"),
    /* @__PURE__ */ l("defs", {}, "1")
  ],
  "UnSmartFolder"
), m2 = e(
  /* @__PURE__ */ l(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M20.99 14.04V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h10.05c.28 1.92 2.1 3.35 4.18 2.93 1.34-.27 2.43-1.37 2.7-2.71.25-1.24-.16-2.39-.94-3.18m-2-9.04L12 8.5 5 5zm-3.64 10H5V7l7 3.5L19 7v6.05c-.16-.02-.33-.05-.5-.05-1.39 0-2.59.82-3.15 2m5.15 2h-4v-1h4z",
      clipRule: "evenodd"
    }
  ),
  "Unsubscribe"
), M2 = e(
  /* @__PURE__ */ l(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M11 8v5l4.25 2.52.77-1.28-3.52-2.09V8zm10 2V3l-2.64 2.64C16.74 4.01 14.49 3 12 3c-4.97 0-9 4.03-9 9s4.03 9 9 9 9-4.03 9-9h-2c0 3.86-3.14 7-7 7s-7-3.14-7-7 3.14-7 7-7c1.93 0 3.68.79 4.95 2.05L14 10z",
      clipRule: "evenodd"
    }
  ),
  "Update"
), R2 = e(
  /* @__PURE__ */ l(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M13.0001 5.6449v12.716h-2V5.6449l-4.8218 4.4508-1.3565-1.4696L12 2l7.1782 6.6261-1.3565 1.4696zM4 16H2v6h20v-6h-2v4H4z",
      clipRule: "evenodd"
    }
  ),
  "Upload"
), H2 = e(
  /* @__PURE__ */ l(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M3 7h2v2H3zm0 8h2v2H3zm0-4h2v2H3zm16-4h2v2h-2zm0 4h2v2h-2zM7 3v2h2V3zm0 18v-2h2v2zm8-18v2h2V3zM3 5V3h2v2zm0 14v2h2v-2zm8-14V3h2v2zm0 14v2h2v-2zm8-14V3h2v2zm-7 10c1.6569 0 3-1.3431 3-3s-1.3431-3-3-3-3 1.3431-3 3 1.3431 3 3 3m0 2c1.0191 0 1.967-.3049 2.7574-.8284l4.8097 4.8097 1.4142-1.4143-4.8097-4.8096A4.977 4.977 0 0 0 17 12c0-2.7614-2.2386-5-5-5s-5 2.2386-5 5 2.2386 5 5 5",
      clipRule: "evenodd"
    }
  ),
  "ZoomSelect"
);
export {
  r as AccountCircle,
  d as AddComponent,
  v as AddFolder,
  h as AddNotes,
  t as AddToCalendar,
  i as AdminPanelSettings,
  u as AdvancedSearch,
  s as AirplanemodeActiveOutlined,
  p as Alarm,
  S2 as Alert,
  a as Area,
  z as ArrowDown,
  f as ArrowLeft,
  C as ArrowRight,
  M as ArrowUp,
  m as Arrows,
  R as Bin,
  H as Bookmark,
  V as BurgerMenu,
  L as CaseStudy,
  S as Chart,
  A as Chat,
  A2 as ChevronDown,
  g as ChevronLeft,
  g2 as ChevronRight,
  y as ChevronUp,
  P as ChevronUpDown,
  k as Circle,
  w as Close,
  q as Component,
  D as Composite,
  F as Compress,
  T as ContentCopy,
  U as ContentCopySharp,
  b as Coordinates,
  E as CrosshairsInner,
  O as CrosshairsOuter,
  Q as DoubleChevronDown,
  x as DoubleChevronLeft,
  I as DoubleChevronRight,
  B as DoubleChevronUp,
  G as Download,
  W as Drag,
  Z as Edit,
  N as Envelope,
  j as Equivalent,
  K as Expand,
  J as Eye,
  X as EyeHidden,
  Y as File,
  _ as Filter,
  $ as Folder,
  l1 as FolderPlus,
  e1 as Graph,
  o1 as GroupAdd,
  c1 as GroupRemove,
  n1 as Heart,
  r1 as HeartFilled,
  d1 as Help,
  v1 as History,
  h1 as HistoryManage,
  t1 as HistoryToggleOff,
  i1 as Home,
  y2 as Info,
  u1 as InspectComponent,
  s1 as Key,
  p1 as Layers,
  a1 as Like,
  z1 as LikeCircle,
  f1 as Link,
  C1 as LinkAdd,
  m1 as LinkOff,
  M1 as ListView,
  R1 as LocationTag,
  H1 as Lock,
  V1 as Map,
  L1 as MarkEmailRead,
  S1 as Measure,
  A1 as Minus,
  g1 as Money,
  y1 as MoneyNotes,
  P1 as MoreHorizontal,
  k1 as MoreVertical,
  w1 as ParkOutlined,
  q1 as Pen,
  D1 as Pencil,
  F1 as People,
  T1 as Person,
  U1 as PersonAdd,
  b1 as PersonManage,
  E1 as PersonOff,
  O1 as Play,
  Q1 as Plus,
  x1 as Point,
  I1 as Pointer,
  B1 as Polygon,
  G1 as Polyline,
  W1 as Print,
  Z1 as PrivateDesign,
  N1 as Rectangle,
  j1 as ReferenceComponent,
  K1 as ReferenceDesign,
  J1 as Refresh,
  X1 as Replay,
  Y1 as Rubber,
  _1 as Search,
  $1 as Select,
  l2 as Send,
  e2 as SendCancel,
  o2 as Settings,
  c2 as Share,
  n2 as SmartFolder,
  r2 as Snapping,
  d2 as SpatialQuery,
  v2 as Star,
  h2 as StarFilled,
  t2 as StreetView,
  i2 as SuccessFilled,
  u2 as Swipe,
  s2 as Tag,
  p2 as Tick,
  P2 as TickCircleOutline,
  a2 as TileView,
  z2 as Time,
  C2 as UnSmartFolder,
  f2 as Undock,
  m2 as Unsubscribe,
  M2 as Update,
  R2 as Upload,
  k2 as Warning,
  H2 as ZoomSelect
};
//# sourceMappingURL=index.js.map
